import { createAsyncThunk } from '@reduxjs/toolkit';

export const onForceRefetchDocuments = createAsyncThunk(
  'onForceRefetchDocuments',
  async (
    data: { projectId?: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    dispatch(
      extra.apiSlice.endpoints.getDocumentsByProject.initiate(
        {
          projectId: data.projectId?.replace('"', ''),
        },
        {
          forceRefetch: true,
        }
      )
    );
  }
);

export default onForceRefetchDocuments;
